import axiosInstance from '../auth/axiosConfig';
import {
  BAJAS_DASHBOARD_REQUEST,
  BAJAS_DASHBOARD_SUCCESS,
  BAJAS_DASHBOARD_FAIL,
} from './types';
import { Dispatch } from 'redux';


export const bajasActions = (anioSeleccionado: number, establ_corr: number) => async (dispatch: Dispatch): Promise<boolean> => {

  dispatch({ type: BAJAS_DASHBOARD_REQUEST });

  try {
    const res = await axiosInstance.get(`${import.meta.env.VITE_CSRF_API_URL}/bajasActions?anioSeleccionado=${anioSeleccionado}&establ_corr=${establ_corr}`);

    if (res.status === 200) {
      if (res.data) {
        dispatch({
          type: BAJAS_DASHBOARD_SUCCESS,
          payload: res.data
        });
        return true;
      }

    } else {
      dispatch({ type: BAJAS_DASHBOARD_FAIL });
    }
    return false;
  } catch (err: any) {
    dispatch({
      type: BAJAS_DASHBOARD_FAIL,
      error: "Error en la solicitud:", err,
    });
    return false;
  }
};
